// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* This file is DEPRECATED
   We are moving to the Octopus Design System
   https://www.octopus.design
  
   When changing component styles:
   1. Do not use variables from this file
   2. Aim to use Emotion \`css\` + themeTokens.colors
       - see Dashboard.tsx for example
   3. If you need to use Less, reference CSS variables
       - see index.ejs for example
       - for full list see https://github.com/OctopusDeploy/OctopusDeploy/blob/main/frontend/packages/design-system-tokens/src/generated/themeTokens.ts
   4. Remove variables from this file when they are no longer used
 */
.SimpleSelect_container__HOLoE {
  position: relative;
  width: 100%;
  padding: 0.5rem 0;
}
.SimpleSelect_label__cAgJ2 {
  display: block;
  font-size: 0.75rem;
  line-height: 1.375rem;
  color: var(--colorTextTertiary);
  font-weight: normal;
  user-select: none;
}
.SimpleSelect_row__e9iXi {
  display: flex;
  align-items: center;
  cursor: pointer;
  min-height: 1.5rem;
}
.SimpleSelect_value__GsaUu {
  flex: 1 1 auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(--colorTextPrimary);
  font-size: 1rem;
  line-height: 1.5rem;
}
.SimpleSelect_placeholder__M22kC {
  flex: 1 1 auto;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(--colorTextTertiary);
  font-size: 1rem;
  line-height: 1.5rem;
}
.SimpleSelect_iconContainer__KdV2y {
  flex: 0 0 auto;
}
.SimpleSelect_underline__p2y5u {
  height: 1px;
  background-color: var(--colorBorderTertiary);
  margin-top: 0.25rem;
}
.SimpleSelect_underlineError__R9UVb {
  height: 1px;
  background-color: var(--colorTextDanger);
  margin-top: 0.25rem;
}
.SimpleSelect_error__XiG46 {
  color: var(--colorTextDanger);
  font-size: 0.75rem;
  line-height: 1rem;
  margin-top: 0.25rem;
}
.SimpleSelect_menuContainer__u3gxA {
  max-height: 31.25rem;
  overflow-y: auto;
  min-width: 16rem;
}
`, "",{"version":3,"sources":["webpack://./app/components/form/Select/SimpleSelect.less"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;AAVF;EACI,kBAAA;EACA,WAAA;EACA,iBAAA;AAYJ;AATA;EACI,cAAA;EACA,kBAAA;EACA,qBAAA;EACA,+BAAA;EACA,mBAAA;EACA,iBAAA;AAWJ;AARA;EACI,aAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AAUJ;AAPA;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,8BAAA;EACA,eAAA;EACA,mBAAA;AASJ;AANA;EACI,cAAA;EACA,gBAAA;EACA,mBAAA;EACA,uBAAA;EACA,+BAAA;EACA,eAAA;EACA,mBAAA;AAQJ;AALA;EACI,cAAA;AAOJ;AAJA;EACI,WAAA;EACA,4CAAA;EACA,mBAAA;AAMJ;AAHA;EACI,WAAA;EACA,wCAAA;EACA,mBAAA;AAKJ;AAFA;EACI,6BAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AAIJ;AADA;EACI,oBAAA;EACA,gBAAA;EACA,gBAAA;AAGJ","sourcesContent":["@import \"../../../resources/styles/colors\";\n\n.container {\n    position: relative;\n    width: 100%;\n    padding: 0.5rem 0;\n}\n\n.label {\n    display: block;\n    font-size: 0.75rem;\n    line-height: 1.375rem;\n    color: @secondaryText;\n    font-weight: normal;\n    user-select: none;\n}\n\n.row {\n    display: flex;\n    align-items: center;\n    cursor: pointer;\n    min-height: 1.5rem;\n}\n\n.value {\n    flex: 1 1 auto;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    color: @primaryText;\n    font-size: 1rem;\n    line-height: 1.5rem;\n}\n\n.placeholder {\n    flex: 1 1 auto;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n    color: @secondaryText;\n    font-size: 1rem;\n    line-height: 1.5rem;\n}\n\n.iconContainer {\n    flex: 0 0 auto;\n}\n\n.underline {\n    height: 1px;\n    background-color: @divider;\n    margin-top: 0.25rem;\n}\n\n.underlineError {\n    height: 1px;\n    background-color: @danger;\n    margin-top: 0.25rem;\n}\n\n.error {\n    color: @danger;\n    font-size: 0.75rem;\n    line-height: 1rem;\n    margin-top: 0.25rem;\n}\n\n.menuContainer {\n    max-height: 31.25rem;\n    overflow-y: auto;\n    min-width: 16rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `SimpleSelect_container__HOLoE`,
	"label": `SimpleSelect_label__cAgJ2`,
	"row": `SimpleSelect_row__e9iXi`,
	"value": `SimpleSelect_value__GsaUu`,
	"placeholder": `SimpleSelect_placeholder__M22kC`,
	"iconContainer": `SimpleSelect_iconContainer__KdV2y`,
	"underline": `SimpleSelect_underline__p2y5u`,
	"underlineError": `SimpleSelect_underlineError__R9UVb`,
	"error": `SimpleSelect_error__XiG46`,
	"menuContainer": `SimpleSelect_menuContainer__u3gxA`
};
module.exports = ___CSS_LOADER_EXPORT___;
